import { useMutation, useQueryClient } from "@tanstack/react-query";
import distributorSpecialPriceApi from "../services/distributorSpecialPrice.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR,
  DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableDistributorSpecialPrice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => distributorSpecialPriceApi.enable(id),
    onError: (error: Error) => {
      errorNotification(DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.ENABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(
          DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.ENABLE_ERROR,
        );
        return;
      }
      successNotification(
        DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS.ENABLE_SUCCESS,
      );
      queryClient.invalidateQueries({
        queryKey: ["distributor-special-prices"],
      });
    },
  });
};

export const useDisableDistributorSpecialPrice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => distributorSpecialPriceApi.disable(id),
    onError: (error: Error) => {
      errorNotification(DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.DISABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(
          DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR.DISABLE_ERROR,
        );
        return;
      }
      successNotification(
        DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS.DISABLE_SUCCESS,
      );
      queryClient.invalidateQueries({
        queryKey: ["distributor-special-prices"],
      });
    },
  });
};
